//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    product: {
      required: true,
    },
    categorySlug: {
      required: true,
    },
  },
  components: {},
  computed: {
    description() {
      if (this.product) {
        if (this.product.description) return this.product.description;
        else if (this.product.fields)
          return this.product.fields.table.meta_description;
      }
    },
  },
};
